'use strict';

const TIPOS_UTILIZA_MOBILE = [
  { id: true, descricao: 'Sim' },
  { id: false, descricao: 'Não' }
];
// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('UsuariosService', function($http, $q,
  UsuarioObjectService, RestService, filterFilter, StorageService) {
  return {
    list: function() {
      const filters = {
        no_paginate: true,
        simple: true
      };
      const url = `${SERVER + API_VERSION }usuarios`;

      return $http.get(url, { params: filters });
    },

    listPaginated: function(filters) {
      const params = !filters ? {} : {
        nome_login: filters.nomeCompleto || null,
        funcao: (filters.funcao || {}).id || null,
        page: filters.page || null
      };
      params.all = true;
      params.web = true;

      if (filters.mobile) {
        params.mobile = filters.mobile.id;
      }

      return RestService.getFromUrl(`${SERVER + API_VERSION }usuarios`, params);
    },

    listUsuariosFiltered: function(filters) {
      const params = !filters ? {} : {
        no_paginate: true,
        simple: true
      };
      params.all = true;

      return RestService.getFromUrl(`${SERVER + API_VERSION }usuarios`, params);
    },

    listUsuario: function(id) {
      const url = `${SERVER + API_VERSION }usuarios/${ id || ''}`;
      return $http.get(url, { params: { all: true } });
    },

    getUtilizaMobile: function(id) {
      return filterFilter(TIPOS_UTILIZA_MOBILE, { id: id }, true)[0] || {};
    },

    save: function(usuario) {
      const result = UsuarioObjectService.convertToSend(usuario);
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION }usuarios`,
        data: { usuario: result }
      });
    },

    update: function(usuario) {
      const result = UsuarioObjectService.convertToSend(usuario);
      return $http({
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION }usuarios/${result.id}`,
        data: { usuario: result }
      }).then((userResult) => {
        const user = StorageService.get(KEY_USER);
        const { data } = userResult;
        const changeUserLoggedIn = data.id === user.id;
        if (changeUserLoggedIn) {
          this.setCPFinStorage(data.cpf);
        }
        return userResult;
      });
    },

    delete: function(id) {
      return $http.delete(`${SERVER + API_VERSION }usuarios/${ id}`);
    },

    cadastrarLoginUnificado: function(usuario) {
      const { cpf } = usuario;
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER}${API_VERSION}usuarios/${usuario.id}/cadastrar_cpf_login_unificado`,
        data: { cpf }
      }).then((userResult) => {
        this.setCPFinStorage(cpf);
        return userResult;
      });
    },

    disable: function(usuario) {
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER}${API_VERSION}usuarios/disable/`,
        data: { id: usuario.id }
      });
    },

    getUsuario: function(id) {
      const deferred = $q.defer();

      this.listUsuario(id).then(function(data) {
        deferred.resolve(UsuarioObjectService.convertToObject(data.data));
      }, deferred.reject);

      return deferred.promise;
    },

    saveNotifications: function(usuario, alertas, configuracoes) {
      const data = [];
      for (const alerta in alertas) {
        if (alertas[alerta]) {
          const alertaConfiguracoes = configuracoes[alerta];
          data.push({ tipo: alerta, forma: 'push', configuracoes: alertaConfiguracoes });
        }
      }

      return $http({
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION }usuarios/${ usuario.id }/alertas`,
        data: { alertas: data }
      });
    },

    listResponsaveisAprovacao: function(propriedade, tipo) {
      return $http.get(`${SERVER }v1/usuarios/responsaveis_aprovacao_aplicacao`, {
        params: {
          propriedade: propriedade.id || propriedade,
          tipo: tipo
        }
      });
    },

    setCPFinStorage: function(cpf) {
      const user = StorageService.get(KEY_USER);
      user.cpf = cpf;
      StorageService.set(KEY_USER, user);
    }

  };
});
